
export enum AppPermissionTypeModel {
  AppPermission = 1,
  DelegatedPermission = 2
}
